import { render, staticRenderFns } from "./Form_Summary.vue?vue&type=template&id=38f1bf04&scoped=true&"
import script from "./Form_Summary.vue?vue&type=script&lang=js&"
export * from "./Form_Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1bf04",
  null
  
)

export default component.exports